export const environment = {
  production: false,
  baseUrl: 'https://api.lc.test.procesa.com.py/v1/',
  urlValidacionToken: 'https://api.web.test.procesa.com.py/v1/',
  urlApiNegofin: 'https://api.negofin.test.procesa.com.py/v1/',
  loginUrl: 'https://sistema.test.procesa.com.py',
};
